module.exports = __webpack_public_path__ + "img/growth.db09bc64.png";